import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a straight wall segment with an open doorway. The opening is
// the kit's standard door opening: 0.9 m wide x 2.05 m high, centred on the
// tile, leaving a header above and narrow 0.05 m jambs at both sides.
const PLASTER = "#e8e4dc";
const BASEBOARD = "#c9c2b6";

export const wallDoorway = defineModel({
  id: "wall-doorway",
  batchId: "modern",
  name: "Wall with doorway",
  tags: ["modern", "interior", "structure", "wall", "doorway", "opening"],
  summary: "A straight wall segment with an open 0.9 x 2.05 m doorway.",
  description:
    "A one-tile plastered wall of the Modern Living kit with the kit's " +
    "standard open doorway: 0.9 m wide x 2.05 m high, centred on the tile, " +
    "with a header above and narrow jambs at both sides. Same 0.12 m " +
    "thickness and 2.6 m height as wall-plain.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // header above the opening (2.05 -> 2.6)
      { geometry: new THREE.BoxGeometry(1.0, 0.55, 0.12), color: PLASTER, position: [0, 2.325, 0] },
      // narrow jambs at both sides of the 0.9 m opening
      { geometry: new THREE.BoxGeometry(0.05, 2.05, 0.12), color: PLASTER, position: [-0.475, 1.025, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 2.05, 0.12), color: PLASTER, position: [0.475, 1.025, 0] },
      // baseboard stubs on the jambs
      { geometry: new THREE.BoxGeometry(0.05, 0.1, 0.15), color: BASEBOARD, position: [-0.475, 0.05, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.1, 0.15), color: BASEBOARD, position: [0.475, 0.05, 0] },
    ];
  },
  animations: [],
});
